import $ from 'jquery'
import { Alert } from '../functions'

// eslint-disable-next-line no-undef
const object = nrjObject
const form = $('.block-form-contact')

form.find('#object').on('change', function () {
  const index = $(this).find(':selected').index()
  const check = $(this).attr('data-cv') * 1
  const cvActive = index === check
  const cvRow = form.find('.cv-row')
  const cv = form.find('#cv')

  if (cvActive) {
    cvRow.slideDown().addClass('cv-row--active')
    cv.attr('name', 'cv')
    cv.prop('required', true)
  } else {
    cvRow.slideUp().removeClass('cv-row--active')
    cv.removeAttr('name')
    cv.prop('required', false)
  }
})

form.on('submit', function (e) {
  e.preventDefault()
  e.stopPropagation()
  e.stopImmediatePropagation()

  const formData = new FormData($(this)[0])
  formData.append('action', 'nrj_contact_form_block')

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    data: formData,
    processData: false,
    contentType: false,
    beforeSend: function () {
      Alert('warning', 'Veuillez patienter')
    },
    success: function (res) {
      Alert(res.success, res.data.message)

      if (res.success) {
        window.location.href = res.data.redirect
      }
    },
  })
})

const input = document.getElementById('address')
const options = {
  fields: ['address_components', 'name', 'geometry'],
  componentRestrictions: { country: 'fr' },
  strictBounds: false,
}

/*const searchBox = new google.maps.places.Autocomplete(input, options)

searchBox.addListener('place_changed', () => {
  const places = searchBox.getPlace()
})*/
